import { Select, SelectProps } from '@cloudscape-design/components';
import { useEffect, useState } from 'react';
import { LANGUAGE_LIST } from 'src/contstant/commonLabels';

interface LanguageDropdownProps {
  languages?: SelectProps.Option[];
  defaultLanguage?: string;
  selectedLanguage?: string;
  onLanguageChange: (language: string) => void;
  placeholder?: string;
  loadingText?: string;
  testId?: string;
  filterLanguges?: string[];
}

export const LanguageDropdown = ({
  languages = LANGUAGE_LIST,
  defaultLanguage,
  selectedLanguage,
  onLanguageChange,
  placeholder = 'Choose a Language',
  loadingText = 'Loading Languages...',
  testId = 'languages-dropdown',
  filterLanguges,
}: LanguageDropdownProps) => {
  const [selectedOption, setSelectedOption] = useState<SelectProps.Option | undefined>();

  useEffect(() => {
    const currentLanguage = languages.find(
      (lang) => lang.value === (selectedLanguage || defaultLanguage),
    );
    setSelectedOption(currentLanguage);
  }, [selectedLanguage, defaultLanguage, languages]);

  const handleLanguageChange: SelectProps['onChange'] = ({ detail }) => {
    const value = detail.selectedOption?.value;
    if (value) {
      onLanguageChange(value);
    }
  };

  const filteredLanguages = filterLanguges
    ? languages.filter((item) => filterLanguges?.includes(item.value || ''))
    : languages;

  return (
    <Select
      options={filteredLanguages}
      selectedOption={selectedOption || null}
      onChange={handleLanguageChange}
      loadingText={loadingText}
      placeholder={placeholder}
      data-testid={testId}
    />
  );
};
